export const getters = {
  userInfo: state => state.userInfo,
  isSignin (state) { // 是否登录
    if (state.userInfo && state.userInfo.accessToken) {
      return true;
    }
    return false;
  },
  loginUserType: state => state.userInfo && state.userInfo.type,
  clickToken: state => state.clickToken,
  getTenantParams: state => state.tenantParams,
  isAnhui(state) {
    return state.tenantParams.areaCode.indexOf('34') === 0;
  },
  isHeilongjiang(state) {
    return state.tenantParams.areaCode.indexOf('23') === 0;
  }
};
